<ngl-modal [header]="headerLabel" [open]="opened" (openChange)="onOpenChanged($event)">
  <div class="slds-p-around_medium"><ng-content></ng-content></div>
  <ng-template nglModalFooter>
    <button *ngIf="cancelBtn" class="slds-button slds-button_neutral" data-testid="cancelBtn" (click)="onCancel()">
      {{ cancelBtnLabel }}
    </button>
    <button class="slds-button slds-button_brand" data-testid="confirmBtn" (click)="onConfirm()">
      {{ confirmBtnLabel }}
    </button>
  </ng-template>
</ngl-modal>
